// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HbdVS6queWlX80W2NhXw {
  display: block;
}

.FPBOvGicY120sWtqXcwQ {
  padding-bottom: 1rem;
}

.wuwpYlBzaIIICsJQ5b1Y {
  font-size: 1rem;
  font-weight: 600;
  margin: 1rem 0;
}

.sDbiLu_LLnaj3htwnfNZ {
  display: block;
}

.pQjxJ_qe8bp5cEFFNAFl {
  margin-top: 1.5rem;
}

.pQjxJ_qe8bp5cEFFNAFl,
.KoaoXfXpTehCil_O3_7_ {
  margin-top: 1.5rem;
}

.Tn3mjZgEcsVDfW3G6RZG {
  display: grid;
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
  grid-row-gap: 0.9375rem;
  row-gap: 0.9375rem;
  grid-template-columns: repeat(2, calc(50% - 0.625rem));
}

.HhHuFdRwuuQBjMlgvz_w {
  display: block;
}

.wL87VNF5pSmAsJquw9Yn {
  margin-top: 0;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .wuwpYlBzaIIICsJQ5b1Y {
    display: none;
  }

  .FPBOvGicY120sWtqXcwQ {
    padding: 0;
  }

  .HbdVS6queWlX80W2NhXw {
    padding: 0;
  }

  .pQjxJ_qe8bp5cEFFNAFl,
  .KoaoXfXpTehCil_O3_7_ {
    margin-top: 1rem;
  }

  .KoaoXfXpTehCil_O3_7_ {
    width: 100%;
  }

  .mipZltev3ebY5WKfBQZs {
    height: 6rem;
  }

  .Tn3mjZgEcsVDfW3G6RZG {
    display: block;
  }

  .HhHuFdRwuuQBjMlgvz_w {
    width: 100%;
  }
}

@media only screen and
  (max-width: 639px) {
  .wuwpYlBzaIIICsJQ5b1Y {
    display: none;
  }

  .FPBOvGicY120sWtqXcwQ {
    padding: 0;
  }

  .HbdVS6queWlX80W2NhXw {
    padding: 0;
  }

  .pQjxJ_qe8bp5cEFFNAFl,
  .KoaoXfXpTehCil_O3_7_ {
    margin-top: 1rem;
  }

  .KoaoXfXpTehCil_O3_7_ {
    width: 100%;
  }

  .mipZltev3ebY5WKfBQZs {
    height: 6rem;
  }

  .Tn3mjZgEcsVDfW3G6RZG {
    display: block;
  }

  .HhHuFdRwuuQBjMlgvz_w {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BusinessOfferFormV1/BusinessOfferFormV1.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAgB;AAClB;;AAEA;;EAEE,kBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAgB;EAAhB,mBAAgB;EAChB,uBAAa;EAAb,kBAAa;EACb,sDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".businessOfferBlock {\n  display: block;\n}\n\n.title {\n  padding-bottom: 16px;\n}\n\n.subTitle {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 16px 0;\n}\n\n.businessOfferForm {\n  display: block;\n}\n\n.inputLabel {\n  margin-top: 24px;\n}\n\n.inputLabel,\n.submitButton {\n  margin-top: 24px;\n}\n\n.inputs {\n  display: grid;\n  column-gap: 20px;\n  row-gap: 15px;\n  grid-template-columns: repeat(2, calc(50% - 10px));\n}\n\n.inputWrapper {\n  display: block;\n}\n\n.labelContainerClassname {\n  margin-top: 0;\n}\n\n@media (--tablet) {\n  .subTitle {\n    display: none;\n  }\n\n  .title {\n    padding: 0;\n  }\n\n  .businessOfferBlock {\n    padding: 0;\n  }\n\n  .inputLabel,\n  .submitButton {\n    margin-top: 16px;\n  }\n\n  .submitButton {\n    width: 100%;\n  }\n\n  .textarea {\n    height: 96px;\n  }\n\n  .inputs {\n    display: block;\n  }\n\n  .inputWrapper {\n    width: 100%;\n  }\n}\n\n@media (--mobile) {\n  .subTitle {\n    display: none;\n  }\n\n  .title {\n    padding: 0;\n  }\n\n  .businessOfferBlock {\n    padding: 0;\n  }\n\n  .inputLabel,\n  .submitButton {\n    margin-top: 16px;\n  }\n\n  .submitButton {\n    width: 100%;\n  }\n\n  .textarea {\n    height: 96px;\n  }\n\n  .inputs {\n    display: block;\n  }\n\n  .inputWrapper {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"businessOfferBlock": `HbdVS6queWlX80W2NhXw`,
	"title": `FPBOvGicY120sWtqXcwQ`,
	"subTitle": `wuwpYlBzaIIICsJQ5b1Y`,
	"businessOfferForm": `sDbiLu_LLnaj3htwnfNZ`,
	"inputLabel": `pQjxJ_qe8bp5cEFFNAFl`,
	"submitButton": `KoaoXfXpTehCil_O3_7_`,
	"inputs": `Tn3mjZgEcsVDfW3G6RZG`,
	"inputWrapper": `HhHuFdRwuuQBjMlgvz_w`,
	"labelContainerClassname": `wL87VNF5pSmAsJquw9Yn`,
	"textarea": `mipZltev3ebY5WKfBQZs`
};
export default ___CSS_LOADER_EXPORT___;
